import _ from 'lodash'

export const getFullName = (volunteer) => {
    let first = _.get(volunteer, 'user.givenName');
    let last = _.get(volunteer, 'user.familyName');
    return (first && last) ? `${first} ${last}` : (first || last);
}